import React, { useState } from "react";
import { parseRace17Cards, race17CardImg } from "../../../diamondCasinoAllGames/race17/race17Cards";
import CardImg from "../../../../components/CardImg";

/**
 * Race to 17 live cards overlay — reference markup (styled by index.css `.raceto17 .casino-video-cards`):
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container >
 *   .race-total "Total: N" + one div > span > img per card token.
 * Hidden while no card is dealt (first token "1"); the shuffle handle toggles it.
 */
export default function Race17CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  const { cards, totalPoints } = parseRace17Cards(card);
  if (!cards.length) return null;
  const hide = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div className="race-total">Total: {totalPoints}</div>{" "}
        {cards.map((token, i) => (
          <div key={i}>
            <span>
              <CardImg src={race17CardImg(token)} alt="" />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
